<template>
  <v-card class="mx-auto" flat>
    <v-card-title>
      My Attendance Requests
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        dense
        outlined
        hide-details
      ></v-text-field>
      <v-spacer />
      <v-btn small color="primary" @click="dialog = true"> Check In </v-btn>
    </v-card-title>
    <v-divider />
    <!-- Tabs for filtering -->
    <v-tabs v-model="selectedTab">
      <v-tab v-for="tab in tabs" :key="tab">
        {{ tab === "Released" ? "Approved" : tab }}
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="filteredRequests"
        :search="search"
        class="elevation-0"
      >
        <template v-slot:item.endDate="{ item }">
          <span>{{ item.status !== "Open" ? item.endDate : "-" }}</span>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)">
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="item.status === 'Open'"
            color="primary"
            class="mr-2"
            elevation="0"
            @click="requestApproval(item)"
          >
            Check out
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="">
          Check In
          <v-spacer></v-spacer>
          <v-btn fab outlined color="red" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-form
            ref="sendLink"
            v-model="isValid"
            @submit.prevent="createRequest"
          >
            <v-row dense justify="space-between" class="mt-2">
              <v-col cols="12" md="12">
                <v-text-field
                  :rules="rules.userLocation"
                  v-model="formData.userLocation"
                  label="What's your current location?"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-btn rounded type="submit" color="primary">Proceed</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";
import { helper } from "@kinetics254/cassandra-base/utilities";
export default {
  name: "AttendanceRequests",

  data() {
    return {
      search: "",
      dialog: false,
      formData: {
        employeeNo: "",
        userLocation: "",
        location: null,
      },
      selectedTab: 0,
      tabs: ["Open", "Pending Approval", "Released"],
      today: new Date().toISOString().split("T")[0],
      isValid: false,
      location: null,
    };
  },

  mounted() {
    this.getGeolocation();
    this.fetchRequests();
  },

  computed: {
    userData() {
      return AuthService.user;
    },
    requests() {
      return this.$store.getters["Attendance/attendanceGetters"]("requests");
    },
    filteredRequests() {
      let tabName = this.tabs[this.selectedTab];
      return this.requests?.filter((request) => request.status === tabName);
    },
    headers() {
      return [
        {
          text: "RefNo",
          align: "start",
          sortable: true,
          value: "entryNo",
        },
        {
          text: "Check-in Time",
          align: "start",
          sortable: true,
          value: "startDate",
        },
        {
          text: "Check-out Time",
          align: "start",
          sortable: true,
          value: "endDate",
        },
        {
          text: "Specified Location",
          align: "start",
          value: "location",
        },
        {
          text: "Picked Location",
          align: "start",
          value: "originCollection",
        },
        {
          text: "Status",
          align: "start",
          value: "status",
        },
        { text: "Actions", value: "actions", sortable: false },
      ];
    },
    rules() {
      return {
        userLocation: [(value) => !!value || "Your location is required."],
      };
    },
  },
  methods: {
    getStatusColor(status) {
      return helper.getColor(status).color;
    },

    createRequest() {
      /** validate form */
      if (!this.isValid) {
        this.$refs.sendLink.validate();
      } else {
        this.formData.employeeNo = this.userData.employee;
        this.formData.location = this.location;

        this.$store
          .dispatch("Attendance/createRequest", this.formData)
          .then(() => {
            this.dialog = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    requestApproval(item) {
      this.$confirm.show({
        title: "Proceed to check out?",
        text: "Your request will be sent for approval",
        onConfirm: () => {
          this.$store.dispatch("Attendance/requestApproval", {
            entryNo: item.entryNo,
            employeeNo: item.employeeNo,
            updateCheckOutTime: true,
          });
        },
      });
    },

    getGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.locationFound,
          this.error
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },

    locationFound(position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      this.location = { latitude, longitude };
    },

    fetchRequests() {
      this.$store.dispatch("Attendance/getAttendanceRequests", {
        employeeNo: this.userData.employee,
      });
    },
  },
};
</script>
